import { baseApi } from "@/utils/baseApi";

export const dynamicFormApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({
    // Fetch form by name
    fetchByFormName: builder.query({
      query: (formName) => `forms?formName=${formName}`,
      providesTags: (result) => (result ? [{ type: "DropdownOptions" }] : []),
    }),

    // Fetch dropdown options
    fetchDropdownOptions: builder.query({
      async queryFn(memoizedFormFields, _api, _extraOptions, baseQuery) {
        try {
          const options = {};

          await Promise.all(
            memoizedFormFields.map(async (field) => {
              try {
                if (field.optionsReference) {
                  options[field.fieldId] = field.optionsReference.options || [];
                } else if (field.optionsReferenceLink) {
                  const response = await baseQuery({
                    url: field.optionsReferenceLink,
                  });

                  if (response.error) {
                    throw new Error(
                      response.error?.data?.message || "API Error"
                    );
                  }

                  const employees = response?.data?.data?.map((emp) => ({
                    name: emp.employeeName || emp.name,
                    value: emp.empId || emp.value,
                  }));

                  options[field.fieldId] = employees || [];
                }
              } catch (error) {
                options[field.fieldId] = []; // Fallback to an empty array if error occurs
                console.error(
                  `Error fetching options for field ${field.fieldId}:`,
                  error
                );
              }
            })
          );

          return { data: options };
        } catch (error) {
          return {
            error: {
              status: "CUSTOM_ERROR",
              message: error.message || "Failed to load dropdown options.",
            },
          };
        }
      },
      providesTags: ["DropdownOptions"],
    }),

    // Fetch child dropdown options
    fetchChildDropdownOptions: builder.query({
      queryFn: async (
        { optionsReferenceLink, param, changedValue },
        _api,
        _extraOptions,
        baseQuery
      ) => {
        if (!optionsReferenceLink) {
          return {
            error: { message: "Invalid optionsReferenceLink provided" },
          };
        }

        try {
          let fullUrl = optionsReferenceLink;
          if (param && changedValue) {
            const separator = fullUrl.includes("?") ? "&" : "?";
            fullUrl += `${separator}${param}=${changedValue}`;
          }

          const response = await baseQuery({ url: fullUrl, method: "GET" });

          if (response.error) {
            return { error: response.error };
          }

          return { data: response.data };
        } catch (error) {
          console.error("Error fetching child dropdown options:", error);
          return {
            error: { message: "Failed to fetch child dropdown options." },
          };
        }
      },
    }),
  }),
});

// Export hooks
export const {
  useFetchByFormNameQuery,
  useFetchDropdownOptionsQuery,
  useFetchChildDropdownOptionsQuery,
} = dynamicFormApi;
